import React, { FC } from "react";
import { Form, Input } from "antd";
import { Col, Row } from "antd";
import { DatePicker } from "antd";

type PreAuthAdmissionDataProps = {
  form: any;
  disabled?: boolean;
  ageAboveSeventyWithoutReferral: boolean;
  ageBelowSeventyWithoutReferral: boolean;
};

const PreAuthAdmissionData: FC<PreAuthAdmissionDataProps> = ({
  form,
  disabled = false,
  ageAboveSeventyWithoutReferral,
  ageBelowSeventyWithoutReferral,
}) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        PRE-AUTH & ADMISSION DATA
      </div>

      <Form
        form={form}
        labelAlign="left"
        layout="vertical"
        labelWrap
        style={{ width: "100%", padding: "0 15px" }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="POLYCLINIC"
              name="polyClinic"
              // rules={[
              //   {
              //     required: ageAboveSeventyWithoutReferral ? false : true,
              //     message: "Please input polyclinic",
              //   },
              // ]}
            >
              <Input
                disabled={disabled || !ageBelowSeventyWithoutReferral}
                placeholder="Enter polyclinic"
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="BENEFICIARY ID"
              name="beneficiaryId"
              rules={[
                { required: true, message: "Please input beneficiary ID" },
              ]}
            >
              <Input disabled={true} placeholder="Enter beneficiary ID" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="ADMISSION OPD NUMBER"
              name="patientOpdIpdNumber"
              rules={[
                {
                  required: true,
                  message: "Please input admission/OPD number",
                },
              ]}
            >
              <Input disabled={true} placeholder="Enter admission/OPD number" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="REFERRAL ID"
              name="referralId"
              rules={[
                {
                  required: ageAboveSeventyWithoutReferral ? false : true,
                  message: "Please input referral ID",
                },
              ]}
            >
              <Input
                disabled={
                  !(
                    ageAboveSeventyWithoutReferral ||
                    ageBelowSeventyWithoutReferral
                  ) || disabled
                }
                placeholder="Enter referral ID"
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="SERVICE NUMBER"
              name="serviceNumber"
              rules={[
                {
                  required: ageAboveSeventyWithoutReferral ? false : true,
                  message: "Please input service number",
                },
              ]}
            >
              <Input
                disabled={
                  !(
                    ageAboveSeventyWithoutReferral ||
                    ageBelowSeventyWithoutReferral
                  ) || disabled
                }
                placeholder="Enter service number"
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="ADMISSION/OPD DATE/TIME"
              name="opdDate"
              rules={[
                {
                  required: true,
                  message: "Please input admission/OPD date/time",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format={dateFormat}
                disabled={true}
              />
            </Form.Item>
          </Col>

          {/* <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="REMARKS"
              name="remarks"
              rules={[
                {
                  required: true,
                  message: "Please input remarks",
                },
              ]}
            >
              <Input disabled={disabled} placeholder="Enter remarks" />
            </Form.Item>
          </Col> */}
        </Row>
      </Form>
    </div>
  );
};

// use React.memo :- Wrap the component with React.memo so it only re-renders when its props actually change.
export default React.memo(PreAuthAdmissionData);
